import { useQuery, useQueryClient } from '@tanstack/react-query';
import { api } from '../../../shared/api.js';
import { useApiMutation } from '../../../shared/useApi.js';

// مسارات الديون تُعيد { debts, stats } و{ customers } — لا مفتاح `items`،
// فلا يفكّها مُعترض الواجهة إلى مصفوفة وتبقى الإحصاءات متاحة.

export function useDebtsList(params) {
  return useQuery({
    queryKey: ['debts', 'list', params],
    queryFn: async () => {
      const { data } = await api.get('/debts', { params });
      return data || { debts: [], stats: null };
    },
    staleTime: 10_000
  });
}

export function useDebtCustomers(params, enabled = true) {
  return useQuery({
    queryKey: ['debts', 'customers', params],
    enabled,
    queryFn: async () => {
      const { data } = await api.get('/debts/customers', { params });
      return data || { customers: [] };
    },
    staleTime: 10_000
  });
}

export function useCustomerDebts(guardianId) {
  return useQuery({
    queryKey: ['debts', 'customer', guardianId],
    enabled: !!guardianId,
    queryFn: async () => {
      const { data } = await api.get(`/debts/customers/${guardianId}`);
      return data;
    },
    staleTime: 5_000
  });
}

export function useDebt(invoiceId) {
  return useQuery({
    queryKey: ['debts', 'one', invoiceId],
    enabled: !!invoiceId,
    queryFn: async () => {
      const { data } = await api.get(`/debts/${invoiceId}`);
      return data;
    },
    staleTime: 5_000
  });
}

function invalidate(qc) {
  qc.invalidateQueries({ queryKey: ['debts'] });
  // التحصيل النقدي يغيّر رصيد القاصة ونقد الشفت المفتوح.
  qc.invalidateQueries({ queryKey: ['shift'] });
  qc.invalidateQueries({ queryKey: ['shifts'] });
  qc.invalidateQueries({ queryKey: ['cashboxes'] });
}

export function useSettleDebt() {
  const qc = useQueryClient();
  return useApiMutation({
    mutationFn: ({ invoiceId, ...body }) => api.post(`/debts/${invoiceId}/settle`, body).then((r) => r.data),
    onSuccess: () => invalidate(qc)
  });
}

export function useReverseDebtPayment() {
  const qc = useQueryClient();
  return useApiMutation({
    mutationFn: ({ paymentId, reason }) => api.post(`/debts/payments/${paymentId}/reverse`, { reason }).then((r) => r.data),
    successMessage: 'تم إلغاء الدفعة وإرجاع المبلغ',
    onSuccess: () => invalidate(qc)
  });
}
